import { PerakendeFaturaDetayPage } from './../perakende-fatura-detay/perakende-fatura-detay';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { CalendarComponentOptions } from 'ion2-calendar';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
declare var cordova: any;

@Component({
  selector: 'page-perakende-satis-faturalari',
  templateUrl: 'perakende-satis-faturalari.html',
})
export class PerakendeSatisFaturalariPage {
  @ViewChild('sideNavUrunAra') sideNav;
  faturaListesi = [];
  tarih1: any;
  tarih2: any;
  ServerParamet: any = { FirmaAdi: "", FirmaTelefonu: "", FirmaAdres: "", FirmaEmail: "", FirmaWeb: "", FirmaVD: "", FirmaVN: "" };
  pdfdetaydata=[];
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "danger",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public navParams: NavParams) {
    this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
    this.tarih2 = this.tarih1;
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.ServerParamet = sonuc.SonucObject;
    });
  }

  ionViewDidLoad() {
    this.faturalariGetir();
    this.closeNav();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }

  faturalariGetir() {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));

    this.bllOrtak.islem(formData, "PerakendeFaturalari", "", true).then(a => {
      var sonuc = <any>a;
      this.faturaListesi = sonuc.SonucObject;

      this.closeNav();
    });
  }
  DetaylariGoster(fatura) {
    // let modal = this.modalCtrl.create(PerakendeFaturaDetayPage, { vWFatura: fatura });
    // modal.onDidDismiss(data => {
    //   this.ionViewDidLoad();
    // })
    // modal.present();
    this.navCtrl.push(PerakendeFaturaDetayPage,{vWFatura:fatura});
  }

  Islemler(fatura) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Fatura  İşlemleri',
      buttons: [
        {
          text: 'Pdf Yazdır',

          handler: () => {
            this.pdfdetaylari(fatura);
          }

        },
        {
          text: 'Detaylar',

          handler: () => {
            this.DetaylariGoster(fatura);
          }

        },
        
       {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
pdfdetaylari(fatura)
{
  var formdata = new FormData();
  formdata.append("faturaid", fatura.ID.toString());
  this.bllOrtak.islem(formdata, "PerakendeSatisDetaylari", "", true).then(a => {
    var sonuc = <any>a;
    this.pdfdetaydata = sonuc.SonucObject;
    if(this.pdfdetaydata!=null)
    {
      this.pdfMake(fatura);
    }

  });
}
  pdfMake(fatura) {

    var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
      "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
      "<tbody>" +
      "<tr>" +
      "<td style'width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>"+this.ServerParamet.FirmaAdres+"</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'><strong>"+this.ServerParamet.FirmaAdi+"</strong></strong></span></td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>"+this.ServerParamet.FirmaTelefonu+"</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>"+this.ServerParamet.FirmaWeb+"</span></td>" +
      "</tr>" +
      "</tbody>" +
      "</table>" +
      "<div style='float:left;width:100%'>Fatura No:<strong>" + fatura.BelgeNo + "</strong></div>" +
      "<div style='float:left;width:100%;margin:bottom:20px'>Fatura Tarihi:<strong>" + this.ortak.tarih2(fatura.SatisTarihi)+ "</strong></div>" +
      "<div class='card text-center'>" +
      "<div class='card-footer text-muted'>" +
      "Perakende Satış Faturası" +
      "</div>" +
      "</div><hr/>" +
      "<table class='table table-striped table-bordered table-hover'>" +
      "<thead>" +
      "<tr>" +
      "<th>Stok Adı</th>" +
      "<th>Miktar</th>" +
      "<th>B.Fiyat</th>" +
      "<th>Toplam</th>" +
      "</tr>" +
      "</thead>" +
      "<tbody>";
    this.pdfdetaydata.forEach(extre => {
      html = html + "<tr>";
      html = html + "<td>" + extre.StokAdi + "</td>";
      html = html + "<td>" + extre.Miktar + "</td>";
      html = html + "<td>" + extre.BirimFiyat+ "</td>";
      html = html + "<td>" + extre.Tutar.toFixed(2) + "</td>";
      html = html + "</tr>";
      
    });
    html = html + "<table style='width:100%'>";
    html = html + "<tr>";
    html = html + "<td>";
    html = html + "<span style='float:left;width:100%;text-align:right'>Genel Toplam: " + fatura.Toplam.toFixed(2) + " </span>";
    html = html + "</td>";
    html = html + "</tr>";
    html = html + "</table>";
    html = html + "</body></html>";
    html = html + "</tbody></table></body></html>";
    cordova.plugins.pdf.htmlToPDF({
      data: html,
      documentSize: "A4",
      landscape: "portrait",
      type: "share"
    },
      (sucess) => console.log('sucess: ', sucess),
      (error) => console.log('error:', error));
  }


}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/perakende-satis-faturalari/perakende-satis-faturalari.ts